import React from 'react';
import { useTranslation } from 'react-i18next';
import InputInfo from '../input/InputInfo';
import styles from './SectionHeader.module.scss';

type Props = {
    headerName: string;
    leadingIcon?: React.ReactElement;
    infoText?: string;
    headerType: number;
    endOfLineButton?: React.ReactElement;
    initialHeader?: boolean;
};

const SectionHeader = ({
    headerName,
    headerType,
    infoText,
    endOfLineButton,
    initialHeader,
    leadingIcon,
}: Props): React.ReactElement => {
    const { t: txt } = useTranslation();

    const header = (): React.ReactElement => {
        const headerText = txt(headerName);
        if (headerType === 3) {
            return (
                <h3 className={styles.subHeader}>
                    {leadingIcon}
                    {headerText}
                </h3>
            );
        }
        if (headerType === 4) {
            return (
                <h4 className={styles.subHeader4}>
                    {leadingIcon}
                    {headerText}
                </h4>
            );
        }
        return (
            <h2 className={styles.subHeader}>
                {leadingIcon}
                {headerText}
            </h2>
        );
    };

    return (
        <div className={styles.headerAndLinksWrapper}>
            <div className={initialHeader ? styles.initialHeaderWrapper : styles.subHeaderWrapper}>
                {header()}
                {infoText && <InputInfo infoText={infoText} />}
            </div>
            {endOfLineButton}
        </div>
    );
};

export default SectionHeader;
